import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-ink text-parchment flex items-center justify-center px-4">
      <div data-testid="payment-cancel-card" className="max-w-md w-full text-center bg-black/40 backdrop-blur-xl border border-white/10 rounded-xl p-10">
        <XCircle className="w-12 h-12 mx-auto text-parchment/50" strokeWidth={1.5} />
        <h1 className="font-heading text-3xl mt-6">Checkout cancelled</h1>
        <p className="font-body text-sm text-parchment/60 mt-3">No charge was made. The Oracle will wait for you.</p>
        <Button data-testid="cancel-back-btn" onClick={() => navigate("/")} className="mt-8 bg-oracle text-ink hover:bg-[#FFC033] label-caps px-8 py-5">Return</Button>
      </div>
    </div>
  );
}
